export default class SystemData {
    /**
     *
     * @type {SystemData}
     * @static
     * @memberof SystemData
     */
    static _instance = null;

    #platform = '';

    /**
     * @readonly
     * @static
     * @memberof SystemData
     */
    static get Instance() {
        if (this._instance == null) {
            this._instance = new SystemData();
        }

        return this._instance;
    }

    /**
     * 回傳系統
     * @return {string} os
     */
    getPlatform() {
        return this.#platform ;
    }

    /**
     * 設定系統
     * @param {String} platform
     */
    setPlatform(platform) {
        this.#platform = platform;
    }

    /**
     * 轉換路徑成Mac版
     * @param {*} path 路徑 
     * @returns 新路徑 
     */
    changePathToMac(path){
        let newPath = path;
        if(path.includes('file://')){
            newPath = path.slice(6,path.length)
        } 
        return newPath;
    }
}